import { restoreBlock } from '@/lib/blocks/api';

import type { LibraryRow } from './types';

export async function restoreTrashedPage(row: LibraryRow): Promise<void> {
  await restoreBlock(row.id);
}
